import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartItemApi,
  fetchCartProducts,
  updateCartQuantityAPI,
} from "./features/cartSlice";
import { toast } from "react-toastify";
// import axios from "axios";
import Swal from "sweetalert2";
import { toggleWishlistApi, fetchWishlist } from "./features/wishlistSlice";
import deleteIcon from "../assets/images/icons/Trash.png";
import gpay from "../assets/images/icons/gpay.png";
import phonpe from "../assets/images/icons/phonpe.png";
import paytm from "../assets/images/icons/paytm.png";
import defaultimg from "../assets/images/default-img.png";

const Cart = () => {
  const [loadingItems, setLoadingItems] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const { items, error } = useSelector((state) => state.cart);
  const cart = useSelector((state) => state.cart);
  // console.log("cart in cart", cart);
  // const [coupons, setCoupons] = useState([]);
  const wishlistItems = useSelector((state) => state.wishlist?.wishlistItems);
  const [isWishlistLoading, setIsWishlistLoading] = useState(false);

  // console.log("wishlistItems in cart", wishlistItems);

  // const fetchCoupons = async () => {
  //   try {
  //     // setLoading(true);
  //     const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/coupon-list`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     // console.log(response.data)
  //     setCoupons(response.data.data);
  //   } catch (error) {
  //     console.error("Error fetching coupons:", error);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  // const copyToClipboard = (couponCode) => {
  //   const toastId = "coupon-code-Id";
  //   navigator.clipboard
  //     .writeText(couponCode)
  //     .then(() => {
  //       if (!toast.isActive(toastId)) {
  //         toast.success("Coupon code copied!", {
  //           toastId: toastId,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error("Failed to copy coupon code");
  //       console.error("Copy failed:", err);
  //     });
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (user && token) {
      dispatch(fetchCartProducts());
      dispatch(fetchWishlist());
    }
    // fetchCoupons();
    
    // Ensure loader shows for at least 0.4 seconds
    setTimeout(() => {
      setIsLoading(false);
    }, 400);
  }, [dispatch, user, token]);

  const handleQuantityChange = async (productId, newQuantity, weightId) => {
    if (newQuantity < 1) return;

    setLoadingItems((prev) => ({
      ...prev,
      [productId + weightId]: true,
    }));

    try {
      await dispatch(updateCartQuantityAPI(productId, newQuantity, weightId));
    } catch (error) {
      console.error("Error updating quantity:", error);
    } finally {
      setLoadingItems((prev) => ({
        ...prev,
        [productId + weightId]: false,
      }));
    }
  };

  const handleMoveToWishlist = async (productId, weightId) => {
    try {
      // Find the cart item
      const cartItem = items.find(
        (item) =>
          (item?.productId?._id === productId ||
            item?.productId === productId) &&
          item.weightId._id === weightId
      );

      if (!cartItem) {
        toast.error("Product not found in cart");
        return;
      }

      // Get the actual product ID and product data
      const actualProductId = cartItem.productId?._id || cartItem.productId;
      // const productData = cartItem.productId || cartItem;

      setIsWishlistLoading(true);

      // Add to wishlist first
      await dispatch(toggleWishlistApi(actualProductId));

      // If user is logged in, refresh wishlist from server
      if (token) {
        await dispatch(fetchWishlist());
      }

      // Then remove from cart
      await dispatch(
        deleteCartItemApi({
          productId: actualProductId,
          weightId: weightId,
        })
      );
    } catch (error) {
      console.error("Error moving item to wishlist:", error);
      toast.error("Failed to move item to wishlist");
    } finally {
      setIsWishlistLoading(false);
    }
  };

  const handleRemoveItem = (productId, weightId) => {
    if (!productId || !weightId) return;

    Swal.fire({
      title: "What would you like to do?",
      text: "Choose an action for this item",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Remove from Cart",
      denyButtonText: "Move to Wishlist",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      denyButtonColor: "#3c3260",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCartItemApi({ productId, weightId }));
        return;
      }

      if (result.isDenied) {
        const currentWishlist = wishlistItems || [];
        const isInWishlist = currentWishlist.some(
          (item) => item._id === productId
        );

        if (isInWishlist) {
          toast.error("Item already in wishlist");
          return;
        }

        handleMoveToWishlist(productId, weightId);
      }
    });
  };

  const handleInternationalCheckout = () => {
    Swal.fire({
      title: "International Shipping",
      html: `
        <p>We apologize, but we are currently not available for international shipping.</p>
        <p style="margin-top: 15px;">Leave your email and we'll notify you when we launch international shipping!</p>
        <input 
          type="email" 
          id="international-shipping-email" 
          class="swal2-input" 
          placeholder="Enter your email"
          value="${user?.email || ''}"
          style="margin-top: 10px; height: 30px;"
        >`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Notify Me",
      cancelButtonText: "Close",
      confirmButtonColor: "#3c3260",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const email = document.getElementById('international-shipping-email').value;
        if (!email) {
          Swal.showValidationMessage('Please enter your email');
          return false;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
          Swal.showValidationMessage('Please enter a valid email');
          return false;
        }

        return fetch(`${process.env.REACT_APP_BACKEND_URL}/api/waitlist`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` })
          },
          body: JSON.stringify({
            email,
            source: 'international_shipping_modal',
            userAgent: navigator.userAgent,
          })
        })
          .then(response => response.json())
          .then(data => {
            if (!data.success) {
              throw new Error(data.message || 'Failed to submit email');
            }
            return data;
          })
          .catch(error => {
            Swal.showValidationMessage(
              error.message || 'Failed to submit email. Please try again.'
            );
          });
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Thank You!',
          text: 'We will notify you when international shipping becomes available.',
          icon: 'success',
          confirmButtonColor: "#3c3260"
        });
      }
    });
  };

  if (isLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  if (error) {
    return <div className="error">{toast.error(error)}</div>;
  }

  return (
    <>
      <section className="banner-innr" style={{ background: "#3c3260" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="banner-innr-content">
                <h3 style={{ color: "white" }}>Shopping cart</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cart-sec tp-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cart-card">
                {items && items.length === 0 ? (
                  <div className="text-center">
                    <h1>Your cart is empty.</h1>
                    <Link
                      to="/shop"
                      style={{ borderRadius: "50px" }}
                      className="thm-btn mt-2 bg-btn"
                    >
                      Continue Shopping
                    </Link>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table">
                      <thead>
                        <tr>
                          <th>Product Image</th>
                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th>Price</th>
                          <th className="text-center">Total</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {console.log(
                          "items in cart in cart.js in tbody",
                          items
                        )} */}
                        {items.map((item) => {
                          // Handle both data structures
                          const product = item.productId || {
                            _id: item.product_id,
                            productName: item.name,
                            productImages: [item.image],
                          };

                          const weight = item.weightId || item.weights?.[0];
                          const basePrice = weight?.prices?.India || 0;

                          // Calculate prices
                          // const price = item.price || basePrice;
                          const discountedPrice =
                            item.discountedPrice ||
                            basePrice *
                            (1 - (item.discount_percentage || 0) / 100);
                          // const totalPrice =
                          //   item.totalPrice || price * item.quantity;
                          const discountedTotalPrice =
                            item.discountedTotalPrice ||
                            discountedPrice * item.quantity;

                          return (
                            <tr
                              key={
                                item._id || `${item.product_id}-${weight?._id}`
                              }
                            >
                              <td>
                                <Link to={`/productDetails/${product.slug}`}>
                                  <img
                                    src={
                                      product.productImages?.[0] || defaultimg
                                    }
                                    className="img-50"
                                    alt={product.productName}
                                  />
                                </Link>
                              </td>
                              <td>
                                {product.productName}
                                <span className="d-block gm-txt">
                                  {weight?.weightInGrams}g
                                </span>
                              </td>
                              <td>
                                <div className="quantity">
                                  <button
                                    type="button"
                                    className="minus"
                                    onClick={() => {
                                      if (item.quantity === 1) {
                                        handleRemoveItem(
                                          product._id,
                                          weight?._id
                                        );
                                      } else {
                                        handleQuantityChange(
                                          product._id,
                                          item.quantity - 1,
                                          weight?._id
                                        );
                                      }
                                    }}
                                    disabled={
                                      loadingItems[
                                        `${product._id}-${weight?._id}`
                                      ]?.loading
                                    }
                                  >
                                    {loadingItems[
                                      `${product._id}-${weight?._id}`
                                    ]?.loading ? (
                                      <div className="spinner-border spinner-border-sm" />
                                    ) : (
                                      <i className="fas fa-minus" />
                                    )}
                                  </button>
                                  <span>{item.quantity}</span>
                                  <button
                                    type="button"
                                    className="plus"
                                    onClick={() =>
                                      handleQuantityChange(
                                        product._id,
                                        item.quantity + 1,
                                        weight?._id
                                      )
                                    }
                                    disabled={
                                      loadingItems[
                                        `${product._id}-${weight?._id}`
                                      ]?.loading
                                    }
                                  >
                                    {loadingItems[
                                      `${product._id}-${weight?._id}`
                                    ]?.loading ? (
                                      <div className="spinner-border spinner-border-sm" />
                                    ) : (
                                      <i className="fas fa-plus" />
                                    )}
                                  </button>
                                </div>
                              </td>
                              <td>
                                <p className="price">
                                  {/* <del className="original-price">
                                    ₹{Number(price).toFixed(2)}
                                  </del> */}
                                  <span className="discounted-price">
                                    ₹{Number(discountedPrice).toFixed(2)}
                                  </span>
                                </p>
                              </td>
                              <td className="text-center">
                                <p className="total-price">
                                {/* <del className="original-price">
                                    ₹{Number(totalPrice).toFixed(2)}
                                  </del> */}
                                <span className="discounted-price">
                                  ₹{Number(discountedTotalPrice).toFixed(2)}
                                </span>
                                </p>
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <button
                                    className="remove-btn"
                                    onClick={() =>
                                      handleRemoveItem(product._id, weight?._id)
                                    }
                                  >
                                    {/* <i className="fas fa-trash-alt" /> */}
                                    <img
                                      src={deleteIcon}
                                      alt="delete"
                                      style={{
                                        width: "25px",
                                      }}
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
          {items && items.length > 0 && (
            <div className="">
              <div className="cart-total">
                <h5>
                  Subtotal:
                  <span>
                    {/* <del className="original-price">
                      {cart.totalAmount.toFixed(2)} INR
                    </del> */}
                    <span className="discounted-price ms-2">
                      {cart.discountedAmount.toFixed(2)} INR
                    </span>
                  </span>
                </h5>
                <p>Tax included and shipping calculated at checkout</p>
                <div className="row g-3">
                  <div className="col-12 col-md-7">
                    <Link
                      to="/checkout"
                      className="thm-btn bg-btn d-flex flex-column flex-md-row align-items-center justify-content-center w-100"
                    >
                      <span className="mb-3 mb-md-0 me-md-3 text-center">
                        Checkout for Indian Address
                      </span>
                      <div className="d-flex align-items-center gap-2">
                        {[
                          { src: gpay, height: "28px" },
                          { src: phonpe, height: "32px" },
                          { src: paytm, height: "40px" },
                        ].map((payment, index) => (
                          <img
                            key={index}
                            src={payment.src}
                            alt="payment"
                            style={{
                              height: payment.height,
                              objectFit: "contain",
                            }}
                          />
                        ))}
                      </div>
                    </Link>
                  </div>

                  <div className="col-12 col-md-5">
                    <button
                      onClick={handleInternationalCheckout}
                      className="thm-btn bg-btn w-100 h-100"
                    >
                      Checkout for International Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Cart;
